import getFetcher from 'common-swr/utils/fetcher';
import { monolithClient } from '../../utils/api';

const capsFetcher = getFetcher(monolithClient);

export default capsFetcher;
